/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BundleCreate,
  BundleRead,
  GetBundlesParams,
  HTTPValidationError,
  PageBundleRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new bundle.
 * @summary Create Bundle
 */
export const createBundle = (
  bundleCreate: BundleCreate,
  signal?: AbortSignal,
) => {
  return customInstance<number>({
    url: `/api/bundle/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bundleCreate,
    signal,
  });
};

export const getCreateBundleMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBundle>>,
    TError,
    { data: BundleCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBundle>>,
  TError,
  { data: BundleCreate },
  TContext
> => {
  const mutationKey = ["createBundle"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBundle>>,
    { data: BundleCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createBundle(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBundle>>
>;
export type CreateBundleMutationBody = BundleCreate;
export type CreateBundleMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Bundle
 */
export const useCreateBundle = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBundle>>,
      TError,
      { data: BundleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBundle>>,
  TError,
  { data: BundleCreate },
  TContext
> => {
  const mutationOptions = getCreateBundleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many bundles.

Results are paginated.
 * @summary Get Bundles
 */
export const getBundles = (params?: GetBundlesParams, signal?: AbortSignal) => {
  return customInstance<PageBundleRead>({
    url: `/api/bundle/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBundlesQueryKey = (params?: GetBundlesParams) => {
  return ["api", "bundle", ...(params ? [params] : [])] as const;
};

export const getGetBundlesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBundles>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBundlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBundles>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBundlesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBundles>>> = ({
    signal,
  }) => getBundles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBundles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBundlesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBundles>>
>;
export type GetBundlesQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBundles<
  TData = Awaited<ReturnType<typeof getBundles>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetBundlesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBundles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBundles>>,
          TError,
          Awaited<ReturnType<typeof getBundles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBundles<
  TData = Awaited<ReturnType<typeof getBundles>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBundlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBundles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBundles>>,
          TError,
          Awaited<ReturnType<typeof getBundles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBundles<
  TData = Awaited<ReturnType<typeof getBundles>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBundlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBundles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bundles
 */

export function useGetBundles<
  TData = Awaited<ReturnType<typeof getBundles>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBundlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBundles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBundlesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get a bundle by ID.
 * @summary Get Bundle
 */
export const getBundle = (bundleId: number, signal?: AbortSignal) => {
  return customInstance<BundleRead>({
    url: `/api/bundle/${bundleId}`,
    method: "GET",
    signal,
  });
};

export const getGetBundleQueryKey = (bundleId?: number) => {
  return ["api", "bundle", bundleId] as const;
};

export const getGetBundleQueryOptions = <
  TData = Awaited<ReturnType<typeof getBundle>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bundleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBundle>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBundleQueryKey(bundleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBundle>>> = ({
    signal,
  }) => getBundle(bundleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bundleId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getBundle>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetBundleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBundle>>
>;
export type GetBundleQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBundle<
  TData = Awaited<ReturnType<typeof getBundle>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bundleId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBundle>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBundle>>,
          TError,
          Awaited<ReturnType<typeof getBundle>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBundle<
  TData = Awaited<ReturnType<typeof getBundle>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bundleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBundle>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBundle>>,
          TError,
          Awaited<ReturnType<typeof getBundle>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBundle<
  TData = Awaited<ReturnType<typeof getBundle>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bundleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBundle>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bundle
 */

export function useGetBundle<
  TData = Awaited<ReturnType<typeof getBundle>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bundleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBundle>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBundleQueryOptions(bundleId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update a bundle by ID.
 * @summary Update Bundle
 */
export const updateBundle = (bundleId: number, bundleCreate: BundleCreate) => {
  return customInstance<unknown>({
    url: `/api/bundle/${bundleId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: bundleCreate,
  });
};

export const getUpdateBundleMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBundle>>,
    TError,
    { bundleId: number; data: BundleCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBundle>>,
  TError,
  { bundleId: number; data: BundleCreate },
  TContext
> => {
  const mutationKey = ["updateBundle"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBundle>>,
    { bundleId: number; data: BundleCreate }
  > = (props) => {
    const { bundleId, data } = props ?? {};

    return updateBundle(bundleId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBundle>>
>;
export type UpdateBundleMutationBody = BundleCreate;
export type UpdateBundleMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bundle
 */
export const useUpdateBundle = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBundle>>,
      TError,
      { bundleId: number; data: BundleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBundle>>,
  TError,
  { bundleId: number; data: BundleCreate },
  TContext
> => {
  const mutationOptions = getUpdateBundleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete a bundle by ID.
 * @summary Delete Bundle
 */
export const deleteBundle = (bundleId: number) => {
  return customInstance<unknown>({
    url: `/api/bundle/${bundleId}`,
    method: "DELETE",
  });
};

export const getDeleteBundleMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBundle>>,
    TError,
    { bundleId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBundle>>,
  TError,
  { bundleId: number },
  TContext
> => {
  const mutationKey = ["deleteBundle"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBundle>>,
    { bundleId: number }
  > = (props) => {
    const { bundleId } = props ?? {};

    return deleteBundle(bundleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBundle>>
>;

export type DeleteBundleMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Bundle
 */
export const useDeleteBundle = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBundle>>,
      TError,
      { bundleId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBundle>>,
  TError,
  { bundleId: number },
  TContext
> => {
  const mutationOptions = getDeleteBundleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Restore an archived (soft-deleted) bundle.
 * @summary Restore Bundle
 */
export const restoreBundle = (bundleId: number, signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/api/bundle/restore/${bundleId}`,
    method: "POST",
    signal,
  });
};

export const getRestoreBundleMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreBundle>>,
    TError,
    { bundleId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreBundle>>,
  TError,
  { bundleId: number },
  TContext
> => {
  const mutationKey = ["restoreBundle"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreBundle>>,
    { bundleId: number }
  > = (props) => {
    const { bundleId } = props ?? {};

    return restoreBundle(bundleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreBundle>>
>;

export type RestoreBundleMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Restore Bundle
 */
export const useRestoreBundle = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreBundle>>,
      TError,
      { bundleId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restoreBundle>>,
  TError,
  { bundleId: number },
  TContext
> => {
  const mutationOptions = getRestoreBundleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
